const setInitial = (state, userId, initialUserState) => {
  const newState = { ...state };
  if (!state[userId]) {
    newState[userId] = initialUserState;
  }
  return newState;
};

export default setInitial;
